import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';
import { ROUTES } from '../constants/api';

/**
 * ProtectedRoute
 * Wraps any route that requires authentication.
 * Unauthenticated users are silently redirected to the login page.
 *
 * @param {{ children: React.ReactNode }} props
 */
export default function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return children;
}
